import type { LoaderMode } from './types';

/** Resolves the loader mode in priority order:
 *   1. URL param `?cb=mock` or `?cb=live`
 *   2. Env var `VITE_CB_LOADER` set to 'mock' or 'live'
 *   3. Build kind — production → 'live', dev → 'mock'
 *
 *  Cf. CODEBABY_GUIDE.md §7. Prod-defaults-to-live is deliberate:
 *  deployed builds talk to real CodeBaby out of the box; dev burns
 *  no API calls unless you opt in. */
export function loaderMode(): LoaderMode {
  if (typeof window !== 'undefined' && window.location?.search) {
    const params = new URLSearchParams(window.location.search);
    const q = params.get('cb');
    if (q === 'live') return 'live';
    if (q === 'mock') return 'mock';
  }

  const env = import.meta.env.VITE_CB_LOADER;
  if (env === 'live') return 'live';
  if (env === 'mock') return 'mock';

  return import.meta.env.DEV ? 'mock' : 'live';
}
